import { AxiosResponse } from 'axios'
import dayjs from 'dayjs'
import { axiosClient, unauthenticatedAxiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { UserInfo, UserSettings } from '@Entities/user/user'
import { Au10tixWorkflowResponseDTO } from '@Entities/au10tix/au10tix-workflow'
import { UserRegistrationType } from '@Entities/schemas/user/user-registration'

export const getUserInfo = (): Promise<AxiosResponse<UserInfo>> => axiosClient.get<UserInfo>(Pathes.User.userInfo)

export const attemptIdvSignedIn = (userExposedId: string): Promise<AxiosResponse<Au10tixWorkflowResponseDTO>> =>
    axiosClient.post<Au10tixWorkflowResponseDTO>(Pathes.User.attemptIdvSignedIn(userExposedId), {})

export const createUserAndAttemptIdv = (
    user: Partial<UserRegistrationType>
): Promise<AxiosResponse<Au10tixWorkflowResponseDTO>> =>
    unauthenticatedAxiosClient.post(Pathes.User.createUserAndAttemptIdv, {
        ...user,
        birthDate: user.birthDate ? dayjs(user.birthDate).format('YYYY-MM-DD') : undefined,
    })

export const editUserInfo = (user: Partial<UserInfo>): Promise<AxiosResponse> =>
    axiosClient.patch<UserInfo>(Pathes.User.userInfo, user)

export const editUserSettings = (user: Partial<UserSettings>): Promise<AxiosResponse<UserSettings>> =>
    axiosClient.patch<UserSettings>(Pathes.User.editUserSettings, user)

export const activateUser = (activationCode: string): Promise<AxiosResponse> =>
    unauthenticatedAxiosClient.get(Pathes.User.activateUser(activationCode))

export const enrollUser2fa = (
    useSms: boolean,
    email: string,
    password: string,
    phoneCountryCode: string,
    fullPhoneNumber: string
): Promise<AxiosResponse<{ mfa: string }>> =>
    unauthenticatedAxiosClient.post<{ mfa: string }>(Pathes.User.userEnable2fa, {
        useSms: useSms,
        email: email,
        password: password,
        phoneCountryCode: phoneCountryCode,
        fullPhoneNumber: fullPhoneNumber,
    })

export const createUserPassword = (
    activationCode: string,
    newPassword: string,
    phoneCountryCode: string,
    fullPhoneNumber: string
): Promise<AxiosResponse<UserInfo>> => {
    const request = {
        newPassword,
        phoneCountryCode,
        fullPhoneNumber,
    }
    return unauthenticatedAxiosClient.post<UserInfo>(Pathes.User.activateUser(activationCode), request)
}

export const submitPhoneEnrollmentMfaCode = (code: string): Promise<AxiosResponse> =>
    unauthenticatedAxiosClient.post(Pathes.User.userConfirmEnable2fa, { code })

export const sendPasswordResetCode = (): Promise<AxiosResponse> => axiosClient.post(Pathes.User.sendResetPasswordCode)

export const changeUserPassword = (confirmationCode: string, newPassword: string): Promise<AxiosResponse> =>
    axiosClient.post(Pathes.User.userPassChange, {
        confirmationCode,
        newPassword,
    })
